import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import List from './List';
import Render from '../common/Render';
import { requestDataIfNeeded } from './duck';

class Screen extends React.Component {
  componentDidMount() {
    this.props.requestDataIfNeeded();
  }

  renderAfterLoading = () => {
    const { activeProjects, sideProjects, unactiveProjects, t } = this.props;

    return (
      <React.Fragment>
        <List
          projects={activeProjects}
          titlePrefix={t('project.all.activeProjectsTitlePrefix')}
          titlePrefixColor="u-color-blue-violet"
          title={t('project.all.activeProjectsTitle')}
          titleSuffix={t('project.all.activeProjectsTitleSuffix')}
          className="u-margin-bottom"
        />
        <List
          projects={sideProjects}
          titlePrefix={t('project.all.activeSideProjectsTitlePrefix')}
          titlePrefixColor="u-color-shakespeare"
          title={t('project.all.activeSideProjectsTitle')}
          titleSuffix={t('project.all.activeSideProjectsTitleSuffix')}
          className="u-margin-bottom"
        />
        <List
          projects={unactiveProjects}
          titlePrefix={t('project.all.archievedProjectsTitlePrefix')}
          titlePrefixColor="u-color-gray"
          titleColor="u-color-gray"
          title={t('project.all.archievedProjectsTitle')}
          titleSuffix={t('project.all.archievedProjectsTitleSuffix')}
          className="u-margin-bottom"
        />
      </React.Fragment>
    );
  };

  render() {
    const { isLoading, error } = this.props;

    return (
      <Render
        isLoading={isLoading}
        error={error}
        render={this.renderAfterLoading}
      />
    );
  }
}

const mapStateToProps = ({ projects }, { type, status }) => {
  const allProjects = projects.data;
  const allSideProjects =
    projects.data && projects.data.filter((p) => p.type === 'SIDE');

  return {
    isLoading: projects.isLoading,
    error: projects.error,
    activeProjects:
      allProjects &&
      // Mark project as active one
      // if at least one user actively works on this project
      allProjects
        .filter((p) => p.type === 'DEFAULT')
        .filter((project) =>
          project.users.some(
            (u) =>
              u.projects.find((pr) => pr.project === project._id).status ===
              'ACTIVE'
          )
        ),

    sideProjects:
      allSideProjects &&
      allSideProjects.filter((project) =>
        project.users.some(
          (u) =>
            u.projects.find((pr) => pr.project === project._id).status ===
            'ACTIVE'
        )
      ),

    unactiveProjects:
      allProjects &&
      // Mark project as inactive one
      // if none users actively work on this project
      // but exclude in the count the ones who have removed the project
      // from their profiles.
      allProjects.filter((project) =>
        project.users.every(
          (u) =>
            u.projects.find((pr) => pr.project === project._id).status !==
            'ACTIVE'
        )
      ),
  };
};

const mapDispatchToProps = { requestDataIfNeeded };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(Screen));



// WEBPACK FOOTER //
// ./src/projects/Screen.js